import React, { useEffect } from 'react';
import { LogoLoadingIndicator } from '@/components/logo-loading-indicator';
import { PricingManagementScreen } from './pricing-management-screen';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack';
import { useBusinessOrganizationPricingConfig } from '@/experiences/sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useNavigation } from '@react-navigation/native';

type Props = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.PricingManagement
>;

export const PricingManagementScreenWrapper: React.FC<Props> = (props) => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();

  const { loading, error, hasPricingAccess } =
    useBusinessOrganizationPricingConfig();

  useEffect(() => {
    if (!loading && !error && !hasPricingAccess) {
      navigation.replace(SALES_PORTAL_ROUTES.NotFound);
    }
  }, [error, hasPricingAccess, loading, navigation]);

  return loading ? (
    <LogoLoadingIndicator />
  ) : (
    <PricingManagementScreen {...props} />
  );
};
